module.exports = __webpack_public_path__ + "img/background_c4-1-1.c145b9ea.jpg";